import React from 'react';
export function Navbar() {
  return <nav className="fixed top-[41px] left-0 right-0 z-[999] px-4 md:px-12 py-3 md:py-4 flex justify-between items-center bg-black/85 backdrop-blur-[24px] border-b border-border" aria-label="Navegación principal" data-id="element-164">
      <div className="font-display text-[0.9rem] md:text-[1.1rem] tracking-[3px] bg-gradient-to-r from-gold to-cyan text-gradient" data-id="element-165">
        CREADOR MILLONARIO · IA
      </div>
      <a href="#oferta" className="nav-cta bg-gradient-to-br from-gold-dark to-gold text-black px-5 md:px-7 py-2 md:py-2.5 rounded-md font-body font-bold text-[0.7rem] md:text-[0.8rem] tracking-[2px] uppercase no-underline" aria-label="Acceso al ebook por $14.94" data-id="element-166">
        ACCESO · $14.94
      </a>
    </nav>;
}